// The pilot app used hash routes at the site root (/#/t/<id>); map them onto /app.
export function legacyHashTarget(hash: string): string | null {
  if (!hash.startsWith("#/")) return null;

  const path = hash.slice(2).split(/[?#]/)[0] ?? "";
  const [section = "", rawId = ""] = path.split("/");
  const id = safeSegment(rawId);

  switch (section) {
    case "t":
      return id ? `/app/t/${id}` : "/app";
    case "invite":
      return id ? `/app/invite/${id}` : "/app";
    case "r":
      return id ? `/app/runs/${id}` : "/app/runs";
    case "history":
      return "/app/runs";
    case "operator":
      return "/app/ops";
    case "login":
      return "/app/login";
    default:
      return "/app";
  }
}

function safeSegment(raw: string): string {
  if (!raw) return "";
  try {
    return encodeURIComponent(decodeURIComponent(raw));
  } catch {
    return encodeURIComponent(raw);
  }
}
